import { useSite } from "@/contexts/SiteContext";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function Faq() {
  const { sectionContent } = useSite();
  const c = sectionContent("faq");
  if (!c) return null;
  const items = c.items || [];
  if (items.length === 0) return null;

  return (
    <section data-testid="faq-section" className="py-24 lg:py-32" style={{ background: "var(--ct-bg)" }}>
      <div className="max-w-4xl mx-auto px-5 lg:px-8">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-4 mb-4">
            <span className="gold-rule" />
            <span data-el="eyebrow" data-field="eyebrow" className="eyebrow">{c.eyebrow || "Întrebări frecvente"}</span>
            <span className="gold-rule" />
          </div>
          <h2 data-el="title" data-field="title" className="font-serif text-4xl sm:text-5xl leading-tight">{c.title || "Întrebări frecvente"}</h2>
        </div>
        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {items.map((it, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="card-premium px-6 !border">
              <AccordionTrigger data-el="item_title" data-field={`items.${i}.q`} data-testid={`faq-q-${i}`} className="text-left font-serif text-xl py-5 hover:no-underline">{it.q}</AccordionTrigger>
              <AccordionContent data-el="item_body" data-field={`items.${i}.a`} data-testid={`faq-a-${i}`} className="text-base leading-relaxed pb-5" style={{ color: "var(--ct-text-muted)" }}>{it.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
